var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.wrapperType,{tag:"component",staticClass:"module-wrapper",attrs:{"href":_vm.href,"target":"_blank"}},[_c('div',{staticClass:"icon"},[_vm._t("icon")],2),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }